<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <el-dialog title="填写补考原因" :visible.sync="showBkyy" :append-to-body="true" width="450px" center>
        <div style="height: 100px; text-align: center;">
          <div>
            <el-input type="textarea" v-model="ksyKsbkmd.bkyy" style="width:400px" placeholder="请输入 补考原因"></el-input>
          </div>
          <div style=" margin-top: 20px">
            <el-button type="primary" style="width: 100px" @click="resit()">确&nbsp;&nbsp;&nbsp;定</el-button>
          </div>
        </div>
      </el-dialog>
      <el-form :inline="true" :model="form" @submit.native.prevent>
        <el-row>
          <el-col :span="20" style="text-align:left">
            <el-form-item label="批阅状态">
              <el-select v-model="form.zt">
                <el-option label="全部" value=""></el-option>
                <el-option label="未批阅" value="0"></el-option>
                <el-option label="已批阅" value="1"></el-option>
                <el-option label="已复核" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="form.ksmc" style="width:400px" placeholder="请输入考生名称" @keyup.enter.native="query()"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="form.kszh" style="width:150px" placeholder="请输入考生账号" @keyup.enter.native="query()"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query()">查询</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <el-form-item>
              <el-button type="primary" style="border-color: rgb(189 61 79); background-color: rgb(189 61 79);" @click="toQkksList()">缺考考生</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <el-table :data="tableData" style="width: 100%" :border="true" height="400">
          <el-table-column label="我的进度" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.myYjbz" :type="{'1' : 'primary', '2': 'primary', '3': 'success'}[scope.row.myYjbz.charAt(0)]" disable-transitions>
                {{ {'1' : '正在', '2': '已'}[scope.row.myYjbz.charAt(1)] + {'1' : '阅卷', '2': '仲裁', '3': '复核'}[scope.row.myYjbz.charAt(0)] }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="我的评分" width="80" align="center">
            <template slot-scope="scope">{{scope.row.myYjbz && scope.row.myYjbz.charAt(1) === '2' ? scope.row.myZzdf : ''}}</template>
          </el-table-column>
          <el-table-column label="批阅状态" width="160" align="center">
            <template slot-scope="scope">
              <el-tag :type="{'0' : 'danger', '1': 'primary', '2': 'success'}[scope.row.pyzt]" disable-transitions>
                {{getYjztms(scope.row)}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="成绩" width="80" align="center" prop="zzdf"/>
          <el-table-column label="考生账号" width="70" prop="yhzh"/>
          <el-table-column label="考生姓名" width="150" prop="yhmc"/>
          <el-table-column label="所属部门" width="120" prop="bmmc"/>
          <el-table-column label="结果" width="60" prop="jg"/>
          <el-table-column label="交卷方式" width="150" align="center" prop="qzjj"/>
          <el-table-column label="交卷时间" width="150" prop="jssj"/>
          <el-table-column label="答题时长" width="120" prop="dtsc"/>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <template v-if="scope.row.yxbz === '1'">
                <el-button size="mini" @click="handleMarking(scope.$index, scope.row)" :disabled="disableYj(scope.row) " type="primary">
                  阅卷</el-button>
                <el-button size="mini" @click="handleMarking(scope.$index, scope.row)" :disabled="!(scope.row.fhr && (scope.row.pyzt === '1' || scope.row.pyzt === '2'))" type="primary">
                  复核</el-button>
                <el-button size="mini" @click="handleResit(scope.$index, scope.row)" :disabled="!scope.row.fhr " type="danger">
                  补考</el-button>
                <!--
                <el-button size="mini" @click="handleExport(scope.$index, scope.row)" type="success">
                  导出</el-button>
                -->
              </template>
              <template v-else-if="scope.row.yxbz === '9'">
                <span v-html="scope.row.sqlsh ? '该记录不生效' : '该记录已作废'"></span>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[8, 10, 20, 50]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import * as markingPaper from '@/api/markingPaper'
export default {
  data () {
    return {
      autoQueryTimer: null, // 自动查询
      form: {
        ksid: null,
        zt: '',
        ksmc: '',
        kszh: ''
      },
      showBkyy: false,
      ksyKsbkmd: {},
      currentPage: 1,
      pageSize: 8,
      totalNum: 0,
      tableData: []
    }
  },
  components: {
    myHeader
  },
  methods: {
    getYjztms (row) {
      // 未批阅
      if (row.pyzt === '0') {
        if (row.yyjCut < 2) {
          if (row.yyjCut > 0 || row.wyjCut > 0) {
            let yjztms = ''
            if (row.yyjCut > 0) {
              yjztms = yjztms + (yjztms === '' ? '' : '，') + row.yyjCut + '人已批阅'
            }
            if (row.wyjCut > 0) {
              yjztms = yjztms + (yjztms === '' ? '' : '，') + row.wyjCut + '人正在批阅'
            }
            return yjztms
          } else {
            return row.pyztms
          }
        } else if (row.yyjCut === 2) {
          return '待仲裁'
        } else {
          return row.pyztms
        }
      } else {
        return row.pyztms
      }
    },
    disableYj (row) {
      let allowYj = false
      // 如果是未阅卷
      if (row.pyzt === '0') {
        if (row.yjr && (row.myYjbz || (row.yyjCut + row.wyjCut) < 2)) {
          allowYj = allowYj || true
        }
        if (row.zcr && row.yyjCut === 2) {
          allowYj = allowYj || true
        }
      }
      // 如果是已阅卷
      if (row.pyzt === '1') {
        if (row.yjr && row.myYjbz) {
          allowYj = allowYj || true
        }
        // 如果是复核人，有复核就行了，不要阅卷
        if (row.fhr) {
          allowYj = false
        }
      }
      return !allowYj
    },
    toQkksList () {
      const query = {
        ksid: this.form.ksid
      }
      this.$router.replace({
        path: '/markingPaper/qkksList',
        query: query
      })
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = Object.assign({ pageNo: this.currentPage, pageSize: this.pageSize }, this.form)
      markingPaper.getList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    },
    // 阅卷
    handleMarking ($index, row) {
      const query = {
        ksid: row.ksid,
        sjid: row.sjid,
        lsh: row.lsh
      }
      const preview = this.$router.resolve({
        path: '/markingPaper/marking',
        query: query
      })
      window.open(preview.href, '_blank')
    },
    // 导出
    handleExport ($index, row) {
      console.log('正在导出')
    },
    // 补考
    handleResit ($index, row) {
      this.$confirm('确定设置为补考？考生设置为补考后，会增加一次考试机会', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ksyKsbkmd.ylsh = row.lsh
        this.ksyKsbkmd.ksid = row.ksid
        this.ksyKsbkmd.yhid = row.yhid
        this.showBkyy = true
      }).catch(() => {})
    },
    resit () {
      markingPaper.resit(this.ksyKsbkmd).then(res => {
        this.$http.callback(res, () => {
          this.showBkyy = false
          this.$message.success(res.msg)
          this.query(this.currentPage)
        })
      })
    }
  },
  created () {
    this.form.ksid = this.$route.query.ksid
  },
  mounted () {
    // 进入页面后进行查询
    this.query()
    // 定时刷新
    const that = this
    this.autoQueryTimer = setInterval(() => {
      that && that.query && that.query(that.currentPage)
    }, 10000)
  },
  beforeDestroy () {
    console.log('销毁页面', this.autoQueryTimer)
    if (this.autoQueryTimer != null) {
      console.log('销毁了')
      window.clearInterval(this.autoQueryTimer)
      this.autoQueryTimer = null
    }
  }
}
</script>
